// extracted by mini-css-extract-plugin
export default {"path":"svg_path__vOEE3","dash":"svg_dash__bTYsi","path2":"svg_path2__JiLA7","dashTwo":"svg_dashTwo__eD0IN"};